<template>
  <a-modal
    title="菜单权限"
    width="800px"
    :open="menuVisible"
    @cancel="handleCancel"
    @ok="handleSubmit"
  >
    <a-table
      :row-selection="{ ...rowSelection, selectedRowKeys: permissionIds }"
      :columns="columns"
      :data-source="transformedMenuList"
      rowKey="id"
      :pagination="false"
    >
    </a-table>
  </a-modal>
</template>
<script>
import { toRefs, inject, reactive, computed } from 'vue'
import { role_create_menu_post } from 'server/modules/351.js'
import { message } from 'ant-design-vue'

export default {
  setup() {
    const RoleState = inject('roleSetting')
    const state = inject('state')
    // let openMenus = []
    const detailState = reactive({
      // openMenus: [],
      handleSubmit: () => {
        const { permissionIds } = state
        const { roleId } = RoleState
        role_create_menu_post({
          roleId,
          menuIds: permissionIds
        })
          .then(result => {
            if (result.success) {
              message.success(result.data)
              RoleState.menuVisible = false
            } else {
              message.warning(result.retInfo)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          state.setAttrs('permissionIds', selectedRowKeys)

          console.log('onChange', selectedRows)
        },
        onSelect: (record, selected) => {
          detailState.recordChild(selected, record)
          if (record.menuType === 3) {
            return false
          }
          if (selected) {
            if (record.parentId) {
              detailState.deepParent(true, record.parentId)
            }

            detailState.deepSonsId(record)
          } else {
            detailState.cancelSonsId(record)
            detailState.deepParent(false, record.parentId)
          }
        }
      },
      deepSonsId: row => {
        let ids = null
        if (row.childrenList) {
          const o = state.openMenus.find(subitem => {
            return subitem.id === row.id
          })
          o.childrenList = Object.assign([], row.childrenList)
          ids = row.childrenList.reduce((previous, current) => {
            previous.push(current.id)
            if (current.childrenList && current.childrenList.length) {
              previous.concat(detailState.deepSonsId(current))
            }
            return previous
          }, [])
        }
        if (ids) {
          state.permissionIds = state.permissionIds.concat(ids)
          state.permissionIds = [...new Set(state.permissionIds)]
        }
      },
      cancelSonsId: row => {
        state.permissionIds = [...new Set(state.permissionIds)]
        if (row.childrenList) {
          const o = state.openMenus.find(subitem => {
            return subitem.id === row.id
          })
          o.childrenList = []
          row.childrenList.map(v => {
            const index = state.permissionIds.indexOf(v.id) // -1不存在
            if (index > -1) {
              state.permissionIds.splice(index, 1)
            }
            if (v.childrenList) {
              detailState.cancelSonsId(v)
            }
          })
        }
      },
      recordChild: (isSelectd, item) => {
        if (!item.parentId) {
          return false
        }
        const o = state.openMenus.find(subitem => {
          return subitem.id === item.parentId
        })
        // 同级多次点击，父级只加一次
        const index = o.childrenList.findIndex(c => {
          return item.id === c.id
        })
        if (isSelectd) {
          index === -1 && o.childrenList.push(item)
        } else {
          // 自动向上查找，如果上面有child的话，不会删除
          index > -1 && o.childrenList.splice(index, 1)
        }
      },
      // 向上取消或者添加
      deepParent: (isSelected, id) => {
        const deep = id => {
          return state.openMenus.find(item => {
            return item.id === id
          })
        }
        const o = deep(id)
        if (isSelected) {
          o && state.permissionIds.push(o.id)
          detailState.recordChild(isSelected, o)
        } else if (o.childrenList && o.childrenList.length === 0) {
          const index = state.permissionIds.indexOf(o.id) // -1不存在
          if (index > -1) {
            state.permissionIds.splice(index, 1)
          }
          detailState.recordChild(isSelected, o)
        }

        if (o.parentId) {
          detailState.deepParent(isSelected, o.parentId)
        }
        state.permissionIds = [...new Set(state.permissionIds)]
      }
    })

    // 转换数据结构，将 childrenList 转换为 children
    const transformedMenuList = computed(() => {
      const transformData = data => {
        return data.map(item => {
          const newItem = { ...item }
          if (item.childrenList && item.childrenList.length > 0) {
            newItem.children = transformData(item.childrenList)
            delete newItem.childrenList
          }
          return newItem
        })
      }
      return state.menuList ? transformData(state.menuList) : []
    })

    return {
      ...toRefs(detailState),
      ...toRefs(RoleState),
      ...toRefs(state),
      transformedMenuList,
      // ...toRefs(data),
      columns: [
        {
          title: '页面名称',
          dataIndex: 'menuName',
          key: 'menuName',
          width: 240
        },
        {
          title: '页面地址',
          dataIndex: 'menuPath',
          key: 'menuPath'
        },
        {
          title: '',
          dataIndex: 'menuTypeStr',
          key: 'menuTypeStr',
          width: 100
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped></style>
